import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><path d=\"M512 439.588571L330.971429 258.56 258.56 330.971429 439.588571 512l-181.028571 181.028571 72.411429 72.411429L512 584.411429l181.028571 181.028571 72.411429-72.411429L584.411429 512l181.028571-181.028571-72.411429-72.411429L512 439.588571zM512 1024C229.229714 1024 0 794.770286 0 512S229.229714 0 512 0s512 229.229714 512 512-229.229714 512-512 512z\" fill=\"#000000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol